module.exports = __webpack_public_path__ + "static/media/logoM.a55c62ed.png";